import React, { useEffect, useState, useContext, useRef } from 'react'
import cssPracticePinyinIdentification from './PracticePinyinIdentification.module.scss'
import { LUCacheContext, GoToLUSinceActionEnum } from '../../LearningUnit.js';
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "PracticePinyinIdentification"
const INDEX_NONE = -1 // 未播放
// #endregion Constant

// #region Enumeration
// #endregion Enumeration

// #region Member Variables
let mblnInitialized = false
let marrQuestionWithAnswer = []
let marrTestSheetAns4Submit = []
let mintIndex4HistoryItemToShow = 0
let mstrLUSeqNoForLUCacheContext = "" // 用於從LUCacheContext 取出 Cache的LU資料時 指出此LU時所需的Key
let mstrBookCatID = ""
let mstrLUCatSeqNo = ""
let mintIndexAudioPlaying = INDEX_NONE // 正在播放中的Audio Index
let mobjAssigementHistoryList = null
let mintClassID = -1
let mblnPracticeEnable = true // 1) 老師設定 Show Practice/Review to Student 決定是否允許學生作答 2）當有允許時 是否有超過最多作答次數 Submission次數的設定可能是 至多1次 至多2次 或 無限多次
let mstrPracticeDisableMessage = "" // 當不允許Practice時 要顯示的訊息
// #endregion Member Variables

function PracticePinyinIdentification(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [testSheetClickedPosArray, setTestSheetClickedPosArray] = useState(InitTestSheetClickedPosArray(props.LUInfo.Sentence.length)) // 正在作答中 學生所點擊得選項
    const [inTestMode, setInTestMode] = useState(false) // 正在作答中: true, 檢視歷史作答: false
    const [practiceEnable, setPracticeEnable] = useState(true) // 當不允許練習時 要顯示訊息給使用者
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region Init Context Ref
    let mobjLUCacheContext = useContext(LUCacheContext) // 包含所有的歷史作答答案
    console.log("mobjLUCacheContext: ", mobjLUCacheContext)
    // #endregion Init Context Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        console.log("GoToLUSinceActionEnum: ", GoToLUSinceActionEnum)
        console.log("GoToLUSinceAction: ", props.GoToLUSinceAction)
        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        mstrLUSeqNoForLUCacheContext = "LU" + props.LUInfo.LUCatSeqNo // 用於Cache LU資料時 指出此LU的Key
        mobjAssigementHistoryList = mobjLUCacheContext.AssigementHistoryList
        mintIndex4HistoryItemToShow = 0
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo

        if (
            (typeof (window.gSession.Acc.Class) !== 'undefined') &&
            (window.gSession.Acc.Class !== null) &&
            (window.gSession.Acc.Class.length > 0) &&
            (window.gSession.Acc.CurrentClassIndex >= 0) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID !== null) &&
            (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)
        )
        {
            mintClassID = parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID)
        }
        else
        {
            mintClassID = -1
        }

        mblnInitialized = true
    }
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mrefCleanUp.current()
        }
    }, [props.PathName])
    // #endregion useEffect

    // #region Painted Me
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")
        RegisterAudioEvent()

        console.log("mobjLUCacheContext: ", mobjLUCacheContext)
        let objHistoryList = mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext]
        console.log("objHistoryList: ", objHistoryList)

        if ((typeof (objHistoryList) === 'undefined') || (objHistoryList.LessonID !== props.LessonID))
        {
            console.log("need to get Assignment History")
            GetAssignmentAssignAnswer()
        }
        else
        {
            console.log("need Not to get Assignment History")

            if (mobjAssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList.length === 0)
            {
                setInTestMode(true)
            }

            CheckPraceticeEnable()

            setUpdateDataTime(new Date().getTime())
        }
        RegisterLanguageChangeHandler()
        RegisterGlossaryCallback()
    }

    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")
        // 避免離開這個 LU 還收到 Audio Player 的 Callback
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.StopAudio()
        mblnInitialized = false
        mintIndexAudioPlaying = INDEX_NONE
        mblnPracticeEnable = true
        UnregisterLanguageChangeHandler()
        UnregisterGlossaryCallback()
        mstrPracticeDisableMessage = ""
    }
    // #endregion Painted Me

    // #region OnTapHandler

    function SubSubSectionOnTapHandler(LUCatSeqNo)
    {
        console.log(COMP_NAME + ".TryOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        GoToLU(LUCatSeqNo)
    }

    function TryOnTapHandler()
    {
        console.log(COMP_NAME + ".TryOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        ClearTestSheetClickedPosArray()
        setInTestMode(true)
    }

    // 點選 送出答案
    function SubmitOnTapHandler()
    {
        console.log(COMP_NAME + ".SubmitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // prepare data for backend call
        // let arrTestSheetAns4Submit = GetTestSheetAns4Submit(props.LUInfo.Sentence, testSheetClickedPosArray)
        marrTestSheetAns4Submit = GetTestSheetAns4Submit(props.LUInfo.Sentence, testSheetClickedPosArray)
        console.log("marrTestSheetAns4Submit: ", marrTestSheetAns4Submit)

        UploadNewAssignmentResult()
    }

    // #region Google Classroom
    /*===========================================
    summary: 點選 GoogleClassroom 元件
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL;
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置

        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler
    // #endregion Google Classroom

    // 點選 歷史紀錄
    function HistoryOnTapHandler()
    {
        console.log(COMP_NAME + ".HistoryOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // Stop audio
        window.AudioLibs.StopAudio()
        mintIndexAudioPlaying = INDEX_NONE

        let objCallbackData = {
            "Action": "HistoryWindowOpen",
            "CallbackRef": HistoryWindowCallback,
            "LessonID": props.LessonID,
            "AssigementHistoryList": mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList,
            "AssignmentTempAns": null
        }
        props.CallbackRef(objCallbackData)
    }

    function AudioPlayOnTapHandler(Index, AudioFileName)
    {
        console.log(COMP_NAME + ".AudioPlayOnTapHandler: ", Index, AudioFileName)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof (AudioFileName) !== "undefined") &&
            (AudioFileName !== null)
        )
        {
            mintIndexAudioPlaying = Index
            console.log("mintIndexAudioPlaying: ", mintIndexAudioPlaying)
            let strAudioUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Audio, AudioFileName);
            console.log("strAudioUrl: ", strAudioUrl)
            window.AudioLibs.PlayAudio(strAudioUrl)

            setUpdateDataTime(new Date().getTime())
        }
    }
    // #endregion OnTapHandler

    // #region Other Handler
    function LanguageOnChangeHandler()
    {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")
    }

    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler")

        mintIndexAudioPlaying = INDEX_NONE
        setUpdateDataTime(new Date().getTime())
    }

    function PlayAudioCanPlayHandler()
    {
        console.log(COMP_NAME + ".PlayAudioCanPlayHandler: ")

        // CloseLoadingMask()
    }
    // #endregion Other Handler

    // #region LoadingMask and Alert
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    }

    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    }
    // #endregion LoadingMask and Alert

    // #region Toast
    // #endregion Toast

    // #region Component Callback
    function HistoryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".HistoryWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "HistoryWindowDetail")
        {
            console.log("HistoryWindowCallback.HistoryWindowDetail")
            console.log("CallbackObj.AssignmentIndex:", CallbackObj.AssignmentIndex)
            mintIndex4HistoryItemToShow = parseInt(CallbackObj.AssignmentIndex)
            setInTestMode(false)
            setUpdateDataTime(new Date().getTime())
        }
    }

    function GlossaryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".GlossaryWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowGlossary")
        {
            console.log("GlossaryWindowCallback.CloseShowGlossary")
            RegisterAudioEvent() // 因為開啟GlossaryWindow時 Audio Event被註冊過去 所以關閉GlossaryWindow時 要再註冊回此
        }
    }
    // #endregion Component Callback

    // #region Other Functions

    // 判斷是否允許作答
    function CheckPraceticeEnable()
    {
        console.log(COMP_NAME + ".CheckPraceticeEnable")
        let blnEnablePractice = true
        let intAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)

        if (intAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
        {
            // 學生才會套用限制
            console.log("window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]:", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex])
            console.log("IsDCPSectionPracticeShow:", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow)

            console.log("mobjLUCacheContext: ", mobjLUCacheContext)
            console.log("mstrLUSeqNoForLUCacheContext: ", mstrLUSeqNoForLUCacheContext)
            console.log("mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext]: ", mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext])

            let strMsg = ""

            if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 0)
            {
                // Show Practice to Student 不允許Practice
                blnEnablePractice = false
                strMsg = window.gAppUI.MSG_Alert_Msg_BlockedInstructor
            }
            else if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 1)
            {
                // Show Practice to Student 有允許Practice
                let intAssignCount = 0 // 學生之前已Submit的次數
                if (
                    (typeof (mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext]) !== "undefined") &&
                    (mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext] !== null) &&
                    (typeof (mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList) !== 'undefined') &&
                    (mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList !== null) &&
                    (mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList.length > 0)
                )
                {
                    console.log("mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList.length:", mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList.length)
                    intAssignCount = mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList.length
                }
                console.log("intAssignCount: ", intAssignCount)
                console.log("window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax: ", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax)

                // 學生身份
                // let strMsg = ""
                if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 0)
                {
                    // 老師關閉 Practice 或 Review
                    strMsg = window.gAppUI.MSG_Alert_Msg_BlockedInstructor
                    blnEnablePractice = false
                }
                else if (
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) <= 2) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) <= intAssignCount)
                )
                {
                    // 作答次數 超過 設定值
                    if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) === 1)
                    {
                        // 作答次數 超過 一次
                        console.log("Reach one time submission limit")
                        strMsg = window.gAppUI.MSG_Alert_Msg_TestedCountExceededOnce
                        blnEnablePractice = false
                    }
                    else
                    {
                        // 作答次數 超過 兩次
                        console.log("Reach two times submission limit")
                        strMsg = window.gAppUI.MSG_Alert_Msg_TestedCountExceededTwice
                        blnEnablePractice = false
                    }
                }
            }
            console.log("blnEnablePractice: ", blnEnablePractice)

            mblnPracticeEnable = blnEnablePractice
            mstrPracticeDisableMessage = strMsg
            console.log("mblnPracticeEnable: ", mblnPracticeEnable)
            console.log("mstrPracticeDisableMessage: ", mstrPracticeDisableMessage)
            setPracticeEnable(mblnPracticeEnable)
        }
        else
        {
            // 身份為 老師 或 個人 則不會有限制是否可Practice
            mblnPracticeEnable = true
            setPracticeEnable(mblnPracticeEnable)
        }
    }

    function RegisterAudioEvent()
    {
        console.log(COMP_NAME + ".RegisterAudioEvent")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioCanPlayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
    }

    function RegisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".RegisterGlossaryCallback: ")
        // 因為ToolBarTopUnit點擊Glossary開啟後 會搶走AudioEnded, AudioCanPlay事件 所以如果LU有使用Audio Event 就必須在Glossary關閉時 需呼叫mobjCallerInfoForGlossaryWindow.CallbackRef 觸發 讓Audio Event再次註冊到LU
        let objCallbackData = {
            "Action": "RegisterGlossaryCallback",
            "CallbackRef": GlossaryWindowCallback
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".UnregisterGlossaryCallback: ")
        let objCallbackData = {
            "Action": "UnregisterGlossaryCallback"
        }
        props.CallbackRef(objCallbackData)
    }

    function RegisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    }

    function GetTestSheetAns4Submit(SentenceList, TestSheetClickedPosArray)
    {
        console.log(COMP_NAME + ".GetTestSheetAns4Submit: ", SentenceList, TestSheetClickedPosArray)

        let arrAnswer = []

        SentenceList.forEach((Sentence, Index) => {
            console.log("Sentence: ", Sentence, Index)

            let objAns4Submit = {
                SentenceSeqNo: Sentence.SentenceSeqNo,
                PIAnswerPos: TestSheetClickedPosArray[Index]
            }

            arrAnswer.push(objAns4Submit)
        })

        return arrAnswer
    }

    function GoToLU(LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GoToLU")

        let objCallbackData = {
            "LUCatSeqNo": LUCatSeqNo,
            "Action": "GoToLU"
        }
        console.log("objCallbackData:", objCallbackData)
        props.CallbackRef(objCallbackData)
    }

    function InitTestSheetClickedPosArray(TotalSentences)
    {
        console.log(COMP_NAME + ".InitTestSheetClickedPosArray: ", TotalSentences)

        return Array(TotalSentences).fill(-1);
    }

    // 作答中 判斷是否每一題都有填上答案
    function IsTextSheetFinished(TestSheet)
    {
        console.log(COMP_NAME + ".IsTextSheetFinished: ", TestSheet)

        // return (testSheetClickedPosArray.indexOf(-1) !== -1)
        return (TestSheet.indexOf(-1) !== -1)
    }

    // 作答時 點擊選項
    function TextSheetFieldOnClickedHandler(SentenceIndex, ClickedPos)
    {
        console.log(COMP_NAME + ".TextSheetFieldOnClickedHandler:", SentenceIndex, ClickedPos)

        console.log("testSheetClickedPosArray: ", testSheetClickedPosArray)
        if (testSheetClickedPosArray[SentenceIndex] !== ClickedPos)
        {
            let arrCurrentTestSheetClickedPos = [].concat(testSheetClickedPosArray)
            console.log("arrCurrentTestSheetClickedPos: ", arrCurrentTestSheetClickedPos)

            arrCurrentTestSheetClickedPos[SentenceIndex] = ClickedPos
            setTestSheetClickedPosArray([].concat(arrCurrentTestSheetClickedPos))
        }
    }

    function ClearTestSheetClickedPosArray()
    {
        console.log(COMP_NAME + ".ClearTestSheetClickedPosArray:")

        setTestSheetClickedPosArray(InitTestSheetClickedPosArray(props.LUInfo.Sentence.length))
    }
    // #endregion Other Functions

    // #region Get ClassName and Style

    function GetClsTryAgainButton(StateInTestMode, PracticeEnable)
    {
        console.log(COMP_NAME + ".GetClsTryAgainButton: ", StateInTestMode, PracticeEnable)

        let objCls = cssPracticePinyinIdentification.divPracticeToolTryAgainMain

        if (!StateInTestMode)
        {
            let blnEnable = true
            let intAccountRole = window.Globals.GetClassAccountRole()
            if (intAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
            {
                if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 0)
                {
                    blnEnable = false
                }
                else if (
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) <= 2) && // DCPTestedCountMax 老師設定 學生可作答的次數 1: Submission只可1次, 2: Submission只可送出2次, 99: Submission可送出無限多次
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) <= mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList.length)
                )
                {
                    blnEnable = false
                }
            }

            if (
                !blnEnable ||
                !PracticeEnable
            )
            {
                objCls = cssPracticePinyinIdentification.divPracticeToolTryAgainMainDisabled
            }
        }
        else
        {
            objCls = cssPracticePinyinIdentification.divHidden
        }

        return objCls
    }

    function GetClsSubmitButton(StateInTestMode, PracticeEnable)
    {
        console.log(COMP_NAME + ".GetClsSubmitButton: ", StateInTestMode, PracticeEnable);

        let objCls = null
        let blnIsTextSheetFinished = IsTextSheetFinished(testSheetClickedPosArray)

        if (StateInTestMode)
        {
            if (
                !StateInTestMode ||
                blnIsTextSheetFinished ||
                !PracticeEnable)
                {
                console.log("submit button should be disabled")
                objCls = cssPracticePinyinIdentification.divPracticeToolSubmitMainDisabled
            }
            else
            {
                console.log("submit button should be enabled")
                objCls = cssPracticePinyinIdentification.divPracticeToolSubmitMain
            }
        }
        else
        {
            objCls = cssPracticePinyinIdentification.divHidden
        }

        return objCls
    }

    // summary: 取得 歷史紀錄按鈕 Cls
    function GetClsHistoryButton()
    {
        console.log(COMP_NAME + ".GetClsHistoryButton");

        let objCls = cssPracticePinyinIdentification.divPracticeToolHistoryMain

        if (
            (typeof (mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext]) !== "undefined") &&
            (typeof (mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList) !== "undefined") &&
            (mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList.length > 0)
        )
        {
            objCls = cssPracticePinyinIdentification.divPracticeToolHistoryMain
        }
        else
        {
            objCls = cssPracticePinyinIdentification.divPracticeToolHistoryMainDisabled
        }

        return objCls
    }

    function GetClsAudioButton(Index)
    {
        console.log(COMP_NAME + ".GetClsAudioButton:", Index);

        let objCls = cssPracticePinyinIdentification.btnAudioPlayDisabled
        if (mintIndexAudioPlaying !== Index)
        {
            objCls = cssPracticePinyinIdentification.btnAudioPlay
        }

        return objCls
    }

    // 作答用的新題目
    function GetTestSheetTextFieldCls(Clicked)
    {
        console.log(COMP_NAME + ".GetTestSheetTextFieldCls: ", Clicked)

        let objCls = null
        if (Clicked)
        {
            objCls = cssPracticePinyinIdentification.divAnswerMainSelected
        }
        else
        {
            objCls = cssPracticePinyinIdentification.divAnswerMain
        }
        return objCls
    }

    // summary: 取得 答案按鈕 Cls
    function GetClsAnswerField(Correct, IsAnsPos)
    {
        let objCls = cssPracticePinyinIdentification.divAnswerMain
        if (Correct)
        {
            // 學生作答答案正確
            if (IsAnsPos)
            {
                // 正確
                objCls = cssPracticePinyinIdentification.divAnswerMainSuccess
            }
            else
            {
                // 錯誤
                objCls = cssPracticePinyinIdentification.divAnswerMainSubmit
            }
        }
        else
        {
            // 學生作答答案錯誤

            if (IsAnsPos)
            {
                // 正確
                objCls = cssPracticePinyinIdentification.divAnswerMainSubmit
            }
            else
            {
                // 錯誤
                objCls = cssPracticePinyinIdentification.divAnswerMainWrong
            }
        }

        return objCls
    }

    // summary: 取得 答案Icon Cls
    function GetAnswerIconCls(Correct, IsAnsPos)
    {
        let objCls = cssPracticePinyinIdentification.divAnswerIconNone
        if (Correct)
        {
            // 學生作答答案正確
            if (IsAnsPos)
            {
                // 正確
                objCls = cssPracticePinyinIdentification.divAnswerIconSuccess
            }
            else
            {
                // 錯誤
                objCls = cssPracticePinyinIdentification.divAnswerIconNone
            }
        }
        else
        {
            // 學生作答答案錯誤

            if (IsAnsPos)
            {
                // 正確
                objCls = cssPracticePinyinIdentification.divAnswerIconNone
            }
            else
            {
                // 錯誤
                objCls = cssPracticePinyinIdentification.divAnswerIconWrong
            }
        }
        return objCls
    }
    // #endregion Get ClassName and Style

    // #region Web Service After Process
    function UploadNewAssignmentResultAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentResultAfterProcess: ", ReturnData)

        let strAnsArray = JSON.stringify(marrTestSheetAns4Submit)
        // let strAnsArray = "[{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"069\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"070\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"071\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"072\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"073\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"074\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"075\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"076\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"}]"
        let arrAnswer = JSON.parse(strAnsArray)
        console.log("arrAnswer: ", arrAnswer)

        let objNow = new Date()
        let objNewAnsInHistory = {
            AssignID: ReturnData.AssignID,
            Score: ReturnData.Score,
            TestedTime: objNow.ToBCUTCString(),
            AnswerList: arrAnswer
        }

        mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList.unshift(objNewAnsInHistory);
        mintIndex4HistoryItemToShow = 0 // 接著顯示第一筆 (即為這一筆)
        console.log("mobjLUCacheContext: ", mobjLUCacheContext)

        CheckPraceticeEnable()

        setUpdateDataTime(new Date().getTime())
        setInTestMode(false)

        // {
        //     "NewAssignmentID": null,
        //     "AssignID": "11142",
        //     "Score": "75",
        //     "TestedTime": "2021-11-11 07:00:25",
        //     "AnswerList": [
        //         {
        //             "AnswerID": "2444",
        //             "LessonID": "3001",
        //             "SQSeqNo": null,
        //             "CQSeqNo": null,
        //             "FQSeqNo": null,
        //             "CQAnswerPos": null,
        //             "FQAnswer": null,
        //             "RecordedAnsFN": null,
        //             "CompositionAns": null,
        //             "ImageAns01FN": null,
        //             "ImageAns02FN": null,
        //             "ImageAns03FN": null,
        //             "SentenceSeqNo": "69",
        //             "PIAnswerPos": "1",
        //             "PDAnswer": null,
        //             "TRPIndex": null,
        //             "TRSeqNo": null,
        //             "TRScore": null,
        //             "TRAnswer": null,
        //             "TRAudioFN": null,
        //             "TeacherFeedbackAudioFN": null,
        //             "TeacherFeedbackText": null,
        //             "TeacherFeedbackVideoFN": null
        //         },
        //         {
        //             "AnswerID": "2445",
        //             "LessonID": "3001",
        //             "SQSeqNo": null,
        //             "CQSeqNo": null,
        //             "FQSeqNo": null,
        //             "CQAnswerPos": null,
        //             "FQAnswer": null,
        //             "RecordedAnsFN": null,
        //             "CompositionAns": null,
        //             "ImageAns01FN": null,
        //             "ImageAns02FN": null,
        //             "ImageAns03FN": null,
        //             "SentenceSeqNo": "70",
        //             "PIAnswerPos": "1",
        //             "PDAnswer": null,
        //             "TRPIndex": null,
        //             "TRSeqNo": null,
        //             "TRScore": null,
        //             "TRAnswer": null,
        //             "TRAudioFN": null,
        //             "TeacherFeedbackAudioFN": null,
        //             "TeacherFeedbackText": null,
        //             "TeacherFeedbackVideoFN": null
        //         },
        //         {
        //             "AnswerID": "2446",
        //             "LessonID": "3001",
        //             "SQSeqNo": null,
        //             "CQSeqNo": null,
        //             "FQSeqNo": null,
        //             "CQAnswerPos": null,
        //             "FQAnswer": null,
        //             "RecordedAnsFN": null,
        //             "CompositionAns": null,
        //             "ImageAns01FN": null,
        //             "ImageAns02FN": null,
        //             "ImageAns03FN": null,
        //             "SentenceSeqNo": "71",
        //             "PIAnswerPos": "1",
        //             "PDAnswer": null,
        //             "TRPIndex": null,
        //             "TRSeqNo": null,
        //             "TRScore": null,
        //             "TRAnswer": null,
        //             "TRAudioFN": null,
        //             "TeacherFeedbackAudioFN": null,
        //             "TeacherFeedbackText": null,
        //             "TeacherFeedbackVideoFN": null
        //         },
        //         {
        //             "AnswerID": "2447",
        //             "LessonID": "3001",
        //             "SQSeqNo": null,
        //             "CQSeqNo": null,
        //             "FQSeqNo": null,
        //             "CQAnswerPos": null,
        //             "FQAnswer": null,
        //             "RecordedAnsFN": null,
        //             "CompositionAns": null,
        //             "ImageAns01FN": null,
        //             "ImageAns02FN": null,
        //             "ImageAns03FN": null,
        //             "SentenceSeqNo": "72",
        //             "PIAnswerPos": "1",
        //             "PDAnswer": null,
        //             "TRPIndex": null,
        //             "TRSeqNo": null,
        //             "TRScore": null,
        //             "TRAnswer": null,
        //             "TRAudioFN": null,
        //             "TeacherFeedbackAudioFN": null,
        //             "TeacherFeedbackText": null,
        //             "TeacherFeedbackVideoFN": null
        //         },
        //         {
        //             "AnswerID": "2448",
        //             "LessonID": "3001",
        //             "SQSeqNo": null,
        //             "CQSeqNo": null,
        //             "FQSeqNo": null,
        //             "CQAnswerPos": null,
        //             "FQAnswer": null,
        //             "RecordedAnsFN": null,
        //             "CompositionAns": null,
        //             "ImageAns01FN": null,
        //             "ImageAns02FN": null,
        //             "ImageAns03FN": null,
        //             "SentenceSeqNo": "73",
        //             "PIAnswerPos": "1",
        //             "PDAnswer": null,
        //             "TRPIndex": null,
        //             "TRSeqNo": null,
        //             "TRScore": null,
        //             "TRAnswer": null,
        //             "TRAudioFN": null,
        //             "TeacherFeedbackAudioFN": null,
        //             "TeacherFeedbackText": null,
        //             "TeacherFeedbackVideoFN": null
        //         },
        //         {
        //             "AnswerID": "2449",
        //             "LessonID": "3001",
        //             "SQSeqNo": null,
        //             "CQSeqNo": null,
        //             "FQSeqNo": null,
        //             "CQAnswerPos": null,
        //             "FQAnswer": null,
        //             "RecordedAnsFN": null,
        //             "CompositionAns": null,
        //             "ImageAns01FN": null,
        //             "ImageAns02FN": null,
        //             "ImageAns03FN": null,
        //             "SentenceSeqNo": "74",
        //             "PIAnswerPos": "1",
        //             "PDAnswer": null,
        //             "TRPIndex": null,
        //             "TRSeqNo": null,
        //             "TRScore": null,
        //             "TRAnswer": null,
        //             "TRAudioFN": null,
        //             "TeacherFeedbackAudioFN": null,
        //             "TeacherFeedbackText": null,
        //             "TeacherFeedbackVideoFN": null
        //         },
        //         {
        //             "AnswerID": "2450",
        //             "LessonID": "3001",
        //             "SQSeqNo": null,
        //             "CQSeqNo": null,
        //             "FQSeqNo": null,
        //             "CQAnswerPos": null,
        //             "FQAnswer": null,
        //             "RecordedAnsFN": null,
        //             "CompositionAns": null,
        //             "ImageAns01FN": null,
        //             "ImageAns02FN": null,
        //             "ImageAns03FN": null,
        //             "SentenceSeqNo": "75",
        //             "PIAnswerPos": "1",
        //             "PDAnswer": null,
        //             "TRPIndex": null,
        //             "TRSeqNo": null,
        //             "TRScore": null,
        //             "TRAnswer": null,
        //             "TRAudioFN": null,
        //             "TeacherFeedbackAudioFN": null,
        //             "TeacherFeedbackText": null,
        //             "TeacherFeedbackVideoFN": null
        //         },
        //         {
        //             "AnswerID": "2451",
        //             "LessonID": "3001",
        //             "SQSeqNo": null,
        //             "CQSeqNo": null,
        //             "FQSeqNo": null,
        //             "CQAnswerPos": null,
        //             "FQAnswer": null,
        //             "RecordedAnsFN": null,
        //             "CompositionAns": null,
        //             "ImageAns01FN": null,
        //             "ImageAns02FN": null,
        //             "ImageAns03FN": null,
        //             "SentenceSeqNo": "76",
        //             "PIAnswerPos": "1",
        //             "PDAnswer": null,
        //             "TRPIndex": null,
        //             "TRSeqNo": null,
        //             "TRScore": null,
        //             "TRAnswer": null,
        //             "TRAudioFN": null,
        //             "TeacherFeedbackAudioFN": null,
        //             "TeacherFeedbackText": null,
        //             "TeacherFeedbackVideoFN": null
        //         }
        //     ],
        //     "Fieldir": "Account_459/DCP/NewAssignment/NewAssignment/NewAssignment_11142"
        // }

        // let objAlertObject = {
        //     Header: null,
        //     Body: window.gAppUI.MSG_SubmitSuccess,
        //     CallbackRef: null,
        //     Buttons: [{
        //         Text: PackageVariablesLibs.UISettings.BTN_OK,
        //         AutoFocus: true
        //     }]
        // }
        // refs.refAlertWindow.ShowAlert(objAlertObject)
    }

    function GetAssignmentAssignAnswerAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswerAfterProcess", ReturnData)
        mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext] = ReturnData
        console.log("mobjLUCacheContext: ", mobjLUCacheContext)

        console.log("1st")
        if (mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList.length === 0)
        {
            // 無歷史作答時 進入作答畫面
            setInTestMode(true)
        }

        CheckPraceticeEnable()

        setUpdateDataTime(new Date().getTime())
    }
    // #endregion Web Service After Process

    // #region Web Service
    function UploadNewAssignmentResult()
    {
        console.log(COMP_NAME + ".UploadNewAssignmentResult.marrTestSheetAns4Submit:", marrTestSheetAns4Submit)

        let objRetryFuncRef = UploadNewAssignmentResult
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef);
        }
        else
        {
            let objCallbackFuncRef = UploadNewAssignmentResultCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_UploadNewAssignmentResult)


            let objCallData = {
                "Func": "UploadNewAssignmentResult",
                "BookCategoryID": window.gSession.App.BookCatID.toString().PadLeft(2),
                "LessonID": props.LessonID,
                "ClassID": mintClassID,
                "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
                "Score": null,
                "Answer": JSON.stringify(marrTestSheetAns4Submit)
                // "Answer": "[{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"069\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"070\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"071\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"072\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"073\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"074\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"075\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"},{\"SQSeqNo\":\"\",\"SentenceSeqNo\":\"076\",\"CQSeqNo\":\"\",\"FQSeqNo\":\"\",\"CQAnswerPos\":\"\",\"FQAnswer\":\"\",\"RecordedAnsFN\":\"\",\"CompositionAns\":\"\",\"ImageAns01FN\":\"\",\"ImageAns02FN\":\"\",\"ImageAns03FN\":\"\",\"PIAnswerPos\":1,\"PDAnswer\":\"\"}]"
            };
            console.log("UploadNewAssignmentResult.objCallData:", objCallData)
            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    }

    function UploadNewAssignmentResultCallback(Return)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UploadAssignmentResult_No;
        let strErrorTitle = window.gAppUI.ERR_UploadAssignmentResult_Title;
        let strErrMsg = window.gAppUI.ERR_UploadAssignmentResult_Msg;


        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute);
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break;
            }

            console.log("UploadNewAssignmentResultCallback: ErrNo: ", Return.ErrNo);
            console.log("UploadNewAssignmentResultCallback: CalledErrNo: ", Return.CalledErrNo);
        }
        else
        {
            console.log("UploadNewAssignmentResultCallback Return.Data", Return.Data);



            UploadNewAssignmentResultAfterProcess(Return.Data)
        }
    }

    function GetAssignmentAssignAnswer()
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswer: ")

        let objRetryFuncRef = GetAssignmentAssignAnswer
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef);
        }
        else
        {
            let objCallbackFuncRef = GetAssignmentAssignAnswerCallback;
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAssignmentAssignAnswer);

            // Func: "GetNewAssignmentAssignAnswer"
            // AssignID: -1
            // Assignee: 459
            // BookCategoryID: "03"
            // LUCatSeqNo: 11
            // LessonID: "03001"

            let objCallData = {
                "Func": "GetNewAssignmentAssignAnswer",
                "Assignee": window.gSession.Acc.ID,
                "BookCategoryID": window.gSession.App.BookCatID.toString().PadLeft(2),
                "LessonID": props.LessonID,
                "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
                "AssignID": -1
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    }

    function GetAssignmentAssignAnswerCallback(Return)
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswerCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetAssignmentAssignAnswer_No;
        let strErrorTitle = window.gAppUI.ERR_GetAssignmentAssignAnswer_Title;
        let strErrMsg = window.gAppUI.ERR_GetAssignmentAssignAnswer_Msg;

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute);
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break;
            }

            console.log("GetAssignmentAssignAnswerCallback: ErrNo: ", Return.ErrNo);
            console.log("GetAssignmentAssignAnswerCallback: CalledErrNo: ", Return.CalledErrNo);
        }
        else
        {
            console.log("GetAssignmentAssignAnswerCallback Return.Data", Return.Data);

            // mobjLUCacheContext.AssigementHistoryList["LU" + Return.Data.LUCatSeqNo] = Return.Data
            // marrNewAssignmentHistory = Return.Data.NewAssignList

            // setLUCatSeqNo(Return.Data.LUCatSeqNo)
            GetAssignmentAssignAnswerAfterProcess(Return.Data)
        }
    }
    // #endregion Web Service

    // #region Component
    // #endregion Component

    // #region Render

    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if (intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssPracticePinyinIdentification.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }

        return objBlockGoogleClassroomButton
    }

    function RenderHeaderLeftArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderLeftArea")

        let strTitleEN = props.SubSectionDef.Name;
        let strTitleCN = '';
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = props.SubSectionDef.MajorName;
        }
        else
        {
            strTitleCN = props.SubSectionDef.MinorName;
        }

        return (
            <>
                <div className={cssPracticePinyinIdentification.divTitleLeftArea}>
                    {RenderGoogleClassrommButton()}
                    <div className={cssPracticePinyinIdentification.divTitleSubArea}>
                        <div className={cssPracticePinyinIdentification.divLessonIcon}></div>
                        <div className={cssPracticePinyinIdentification.divLUTitleTextEN}>
                            {strTitleEN}
                        </div>
                        <div className={cssPracticePinyinIdentification.divDividerBar}></div>
                        <div className={cssPracticePinyinIdentification.divLUTitleTextCN}>
                            {strTitleCN}
                        </div>
                    </div>
                </div>
            </>
        )
    }

    function RenderSubSubSectionToolArea()
    {
        console.log(COMP_NAME + ".RenderSubSubSectionToolArea: ");

        return (
            <div className={cssPracticePinyinIdentification.divSubSubSectionToolArea}>
                <div className={cssPracticePinyinIdentification.btnPinyinPronunciation} onClick={() => SubSubSectionOnTapHandler(window.gDCPLUEnum.PracticePinyinPronunciation)}>
                    {props.SubSectionDef.SubSubSection[0].Name}
                </div>
                <div className={cssPracticePinyinIdentification.btnPinyinIdentification}>
                    {props.SubSectionDef.SubSubSection[1].Name}
                </div>
                <div className={cssPracticePinyinIdentification.btnPinyinDictation} onClick={() =>
                    SubSubSectionOnTapHandler(window.gDCPLUEnum.PracticePinyinDictation)}>
                    {props.SubSectionDef.SubSubSection[2].Name}
                </div>
            </div>
        )
    }

    function RenderQuestionItemDisablePractice(Item, Index)
    {
        console.log(COMP_NAME + ".RenderQuestionItemDisablePractice: ", Item, Index)
        return (
            <div key={Index} className={cssPracticePinyinIdentification.divUnitMain}>
                {/*  Item Number Field */}
                <div className={cssPracticePinyinIdentification.divNoText}>
                    {Index + 1}.
                </div>
                {/* Play Button Field */}
                <div className={GetClsAudioButton(Index)} onClick={() => AudioPlayOnTapHandler(Index, Item.AudioFN)}></div>
                {/* 1st Text Field */}
                <div className={cssPracticePinyinIdentification.divAnswerMainDisable}>
                    {Item.Pinyin}
                </div>
                {/* 2nd Text Field */}
                <div className={cssPracticePinyinIdentification.divAnswerMainDisable}>
                    {Item.Pinyin}
                </div>
            </div>
        )
    }

    function RenderQuestionItemWithoutAnswer(Item, Index, TestSheetClickedPos)
    {
        console.log(COMP_NAME + ".RenderQuestionItemWithoutAnswer: ", Item, Index, TestSheetClickedPos)
        return (
            <div key={Index} className={cssPracticePinyinIdentification.divUnitMain}>
                {/*  Item Number Field */}
                <div className={cssPracticePinyinIdentification.divNoText}>
                    {Index + 1}.
                </div>
                {/* Play Button Field */}
                <div className={GetClsAudioButton(Index)} onClick={() => AudioPlayOnTapHandler(Index, Item.AudioFN)}></div>
                {/* 1st Text Field */}
                {/* <div className={GetQuestionRowCls(TestSheetClickedPos)} onClick={() => TextSheetFieldOnClickedHandler(Index, 1)}> */}
                <div className={GetTestSheetTextFieldCls(TestSheetClickedPos === 1)} onClick={() => TextSheetFieldOnClickedHandler(Index, 1)}>
                    {(parseInt(Item.AnswerPos) === 1) ? Item.Pinyin : Item.WrongPinyin}
                </div>
                {/* 2nd Text Field */}
                {/* <div className={GetQuestionRowCls()} onClick={() => TextSheetFieldOnClickedHandler(Index, 2)}> */}
                <div className={GetTestSheetTextFieldCls(TestSheetClickedPos === 2)} onClick={() => TextSheetFieldOnClickedHandler(Index, 2)}>
                    {(parseInt(Item.AnswerPos) === 2) ? Item.Pinyin : Item.WrongPinyin}
                </div>
            </div>
        )
    }

    function RenderQuestionListDisablePractice()
    {
        console.log(COMP_NAME + ".RenderQuestionListDisablePractice: props.LUInfo.Sentence: ", props.LUInfo.Sentence)

        return (
            <div className={cssPracticePinyinIdentification.divSubContentArea}>
                {props.LUInfo.Sentence.map((Item, Index) =>
                    RenderQuestionItemDisablePractice(Item, Index)
                )}
            </div>
        )
    }

    function RenderQuestionListWithoutAnswer(TestSheetClickedPosArray)
    {
        console.log(COMP_NAME + ".RenderQuestionListWithoutAnswer: props.LUInfo.Sentence: ", props.LUInfo.Sentence)

        console.log("TestSheetClickedPosArray: ", TestSheetClickedPosArray)
        return (
            <div className={cssPracticePinyinIdentification.divSubContentArea}>
                {props.LUInfo.Sentence.map((Item, Index) =>
                    RenderQuestionItemWithoutAnswer(Item, Index, TestSheetClickedPosArray[Index])
                )}
            </div>
        )
    }

    function RenderQuestionItemWithAnswer(Item, Index)
    {
        console.log(COMP_NAME + ".RenderQuestionItemWithAnswer: ", Item, Index)
        return (
            <div key={Index} className={cssPracticePinyinIdentification.divUnitMain}>
                {/* Item Number Field */}
                <div className={cssPracticePinyinIdentification.divNoText}>
                    {Index + 1}.
                </div>
                {/* Play Button Field */}
                <div className={GetClsAudioButton(Index)} onClick={() => AudioPlayOnTapHandler(Index, Item.AudioFN)}></div>
                {/* 1st Text Field */}
                <div className={GetClsAnswerField(Item.Correct, Item.Field1.IsAnsPos)}>
                    {Item.Field1.Text}
                    <div className={GetAnswerIconCls(Item.Correct, Item.Field1.IsAnsPos)}></div>
                </div>
                {/* 2nd Text Field */}
                <div className={GetClsAnswerField(Item.Correct, Item.Field2.IsAnsPos)}>
                    {Item.Field2.Text}
                    <div className={GetAnswerIconCls(Item.Correct, Item.Field2.IsAnsPos)}></div>
                </div>
            </div>
        )
    }

    function RenderQuestionListWithAnswer()
    {
        console.log(COMP_NAME + ".RenderQuestionListWithAnswer: marrQuestionWithAnswer:", marrQuestionWithAnswer)
        return (
            <div className={cssPracticePinyinIdentification.divSubContentArea}>
                {marrQuestionWithAnswer.map((Item, Index) =>
                    RenderQuestionItemWithAnswer(Item, Index)
                )}
            </div>
        )
    }

    function GetAnsweredSentenceList(AnswerListFromHistory)
    {
        console.log(COMP_NAME + ".GetAnsweredSentenceList: ", AnswerListFromHistory)

        let arrList = []
        let objSentent = {}

        let i = 0;
        let intLen = props.LUInfo.Sentence.length
        console.log("mstrLUSeqNoForLUCacheContext:", mstrLUSeqNoForLUCacheContext)
        console.log("mintIndex4HistoryItemToShow:", mintIndex4HistoryItemToShow)

        for (i = 0; i < intLen; i++)
        {
            let objSentenceTitle = props.LUInfo.Sentence[i]

            let objSententceAns = mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList[mintIndex4HistoryItemToShow].AnswerList[i]
            console.log("objSentenceTitle: ", objSentenceTitle)
            console.log("objSententceAns: ", objSententceAns)
            objSentent = {
                SentenceSeqNo: parseInt(objSentenceTitle.SentenceSeqNo),
                AudioFN: objSentenceTitle.AudioFN,
                Field1: {
                    Text: (parseInt(objSentenceTitle.AnswerPos) === 1) ? objSentenceTitle.Pinyin : objSentenceTitle.WrongPinyin,
                    IsAnsPos: (parseInt(objSentenceTitle.AnswerPos) === 1) ? true : false //,
                    // Correct: false
                },
                Field2: {
                    Text: (parseInt(objSentenceTitle.AnswerPos) === 2) ? objSentenceTitle.Pinyin : objSentenceTitle.WrongPinyin,
                    IsAnsPos: (parseInt(objSentenceTitle.AnswerPos) === 2) ? true : false //,
                    // Correct: false
                },
                Correct: (parseInt(objSentenceTitle.AnswerPos) === parseInt(objSententceAns.PIAnswerPos)) ? true : false
            }

            console.log("objSentent: ", objSentent)
            arrList.push(objSentent)
        }
        console.log("arrList: ", arrList)

        return arrList
    }

    function RenderSubSubTitleArea()
    {
        console.log(COMP_NAME + ".RenderSubSubTitleArea: ")

        let strTitleEN = props.SubSectionDef.SubSubSection.find(Item => Item.SubSubSectionSeqNo === props.LUInfo.SubSubSectionSeqNo).Name
        let strTitleCN = ""
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = props.SubSectionDef.SubSubSection.find(Item => Item.SubSubSectionSeqNo === props.LUInfo.SubSubSectionSeqNo).MajorName
            console.log("strTitleCN: ", strTitleCN)
        }
        else
        {
            strTitleCN = props.SubSectionDef.SubSubSection.find(Item => Item.SubSubSectionSeqNo === props.LUInfo.SubSubSectionSeqNo).MinorName
            console.log("strTitleCN: ", strTitleCN)
        }

        let strInstruction = props.LUInfo.Instruction.replace(/\n/g, "\r\n")

        return (
            <>
                <div className={cssPracticePinyinIdentification.divLUSubSubTitleArea}>
                    <div className={cssPracticePinyinIdentification.divLUSubSubTitleTextEN}>
                        {strTitleEN}
                    </div>
                    <div className={cssPracticePinyinIdentification.divLUSubSubTitleBar}></div>
                    <div className={cssPracticePinyinIdentification.divLUSubSubTitleTextCN}>
                        {strTitleCN}
                    </div>
                </div>
                <div className={cssPracticePinyinIdentification.divLUInstructionText}>
                    {strInstruction}
                </div>
            </>
        )
    }

    function RenderScoreToolArea()
    {
        console.log(COMP_NAME + ".RenderScoreToolArea: ")

        let strScore = window.gAppUI.LBL_NotScore

        if (!inTestMode)
        {
            strScore = mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext].NewAssignList[mintIndex4HistoryItemToShow].Score.toString()
        }

        return (
            <div className={cssPracticePinyinIdentification.divScoreToolMain}>
                <div className={cssPracticePinyinIdentification.divPracticeToolYourScoreMain}>
                    <div className={cssPracticePinyinIdentification.divPracticeToolText}>
                        {window.gAppUI.LBL_YourScore}:
                    </div>
                    <div className={cssPracticePinyinIdentification.divPracticeScoreText}>
                        {strScore}
                    </div>
                </div>

                <div className={cssPracticePinyinIdentification.divPracticeLine}></div>

                <div className={GetClsHistoryButton()} onClick={() => HistoryOnTapHandler()}>
                    <div className={cssPracticePinyinIdentification.divHistoryIcon}></div>
                    <div className={cssPracticePinyinIdentification.divPracticeToolText}>
                        {window.gAppUI.LBL_History}
                    </div>
                </div>

                <div className={cssPracticePinyinIdentification.divPracticeLine}></div>

                <div className={GetClsTryAgainButton(inTestMode, mblnPracticeEnable)} onClick={() => TryOnTapHandler()}>
                    <div className={cssPracticePinyinIdentification.divTryAgainIcon}></div>
                    <div className={cssPracticePinyinIdentification.divPracticeToolText}>
                        {PackageVariablesLibs.UISettings.BTN_Retry}
                    </div>
                </div>

                <div className={GetClsSubmitButton(inTestMode, mblnPracticeEnable)} onClick={() => SubmitOnTapHandler()}>
                    <div className={cssPracticePinyinIdentification.divSubmitIcon}></div>
                    <div className={cssPracticePinyinIdentification.divPracticeToolText}>
                        {window.gAppUI.BTN_Submit}
                    </div>
                </div>
            </div>
        )
    }

    function RenderContent()
    {
        console.log(COMP_NAME + ".RenderContent: ")
        console.log("AssigementHistoryList: ", mobjLUCacheContext.AssigementHistoryList[mstrLUSeqNoForLUCacheContext])

        let objQuestionListWithoutAnswer = null
        let objQuestionListWithAnswer = null
        console.log("mblnPracticeEnable: ", mblnPracticeEnable)
        if (updateDataTime > 0)
        {
            if (inTestMode)
            {
                if (mblnPracticeEnable)
                {
                    // 可作答
                    console.log("In Test Mode")
                    objQuestionListWithoutAnswer = RenderQuestionListWithoutAnswer(testSheetClickedPosArray)
                }
                else
                {
                    // 不允許作答
                    console.log("Disable Practice")
                    objQuestionListWithoutAnswer = RenderQuestionListDisablePractice()
                }
            }
            else
            {
                console.log("Not In Test Mode")
                marrQuestionWithAnswer = GetAnsweredSentenceList()
                console.log("marrQuestionWithAnswer:", marrQuestionWithAnswer)
                objQuestionListWithAnswer = RenderQuestionListWithAnswer()
            }

            return (
                <>
                    <div className={cssPracticePinyinIdentification.divContentArea}>
                        {RenderSubSubTitleArea()}
                        {RenderScoreToolArea()}
                        {objQuestionListWithoutAnswer}
                        {objQuestionListWithAnswer}
                    </div>
                </>
            )
        }
        else
        {
            return null
        }
    }

    // 不允許編輯的動畫文字
    function RenderAnimationMessageAreaForPracticeDisable(StatePracticeEnable)
    {
        console.log(COMP_NAME + ".RenderAnimationMessageAreaForPracticeDisable: ")
        let objBlock = null
        if (!StatePracticeEnable)
        {
            objBlock = (
                <div className={cssPracticePinyinIdentification.divAnimationMessageAreaForPracticeDisable}>
                    {mstrPracticeDisableMessage}
                </div>
            )
        }
        return objBlock
    }

    return (
        <>
            {RenderHeaderLeftArea()}
            {RenderSubSubSectionToolArea()}
            {RenderContent()}
            {RenderAnimationMessageAreaForPracticeDisable(practiceEnable)}
        </>
    )
    // #endregion Render
}
export default PracticePinyinIdentification